// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CreateCoursePageLayout_wrapper__d5UcZ","main":"CreateCoursePageLayout_main__2ZSQO"};